import { render, staticRenderFns } from "./ProtocolList.vue?vue&type=template&id=1ec3ba54&scoped=true&"
import script from "./ProtocolList.vue?vue&type=script&lang=js&"
export * from "./ProtocolList.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolList.vue?vue&type=style&index=0&id=1ec3ba54&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec3ba54",
  null
  
)

export default component.exports